import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "./authinterceptor";
import AuthHeader from "../services/auth.header";

export const getMenu = createAsyncThunk('catalog/getMenu', async (subsiteId, thunkApi) => {
    console.log("THUNK API", thunkApi);
    try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/categories", { headers: AuthHeader.authHeaderFromState(thunkApi.getState())});
        console.log("CATALOG MENU RESPONSE" , response);
        return response.data;
    } catch (error) {
        console.log(error);
        console.log("RESPONSE STATUS", error.response.status);
    }    
  });

  export const selectAllMenuItems = state => state.menu.menu;
  export const menuStatus = state => state.menu.status;

  const initialState = {
    menu: [],
    status: 'idle',
    error: null
  };

  const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
          .addCase(getMenu.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getMenu.fulfilled, (state, action) => {
            state.status = 'succeeded'
            // Add any fetched posts to the array
            state.menu = action.payload;
          })
          .addCase(getMenu.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
          })
      }
  });
  
  export default menuSlice.reducer;


